import * as Events from './Events';

export default function organizationSubscriptionReducer(state, action) {
    switch(action.type) {
        case Events.PAYMENT_METHODS_LOADED:
            return {
                ...state,
                paymentMethods: [ ...action.payload ]
            }
        case Events.PAYMENT_METHOD_SELECTED:
            return {
                ...state,
                selectedPaymentMethodId: action.payload
            }
        case Events.NEW_CARD_ADDED:
            return {
                ...state,
                paymentMethods: [
                    ...state.paymentMethods,
                    { ...action.payload }
                ]
            }
        case Events.INVOICES_LOADED:
            return {
                ...state,
                invoices: [
                    ...action.payload
                ]
            }
        case Events.PAYMENT_METHOD_UPDATED:
            return {
                ...state,
                paymentMethods: state.paymentMethods.map(paymentMethod => {
                    debugger
                    if (paymentMethod.id === action.payload.paymentMethodId) {
                        return {
                            ...paymentMethod,
                            card: {
                                ...paymentMethod.card,
                                exp_month: action.payload.expiryMonth,
                                exp_year: action.payload.expiryYear
                            }
                        }
                    }

                    return paymentMethod;
                })
            }
        case Events.SET_BILLING_INFORMATION:
            return {
                ...state,
                billingInformation: {
                    ...action.payload
                }
            }
        case Events.SET_TAX_INFO:
            return {
                ...state,
                taxInfo: {
                    ...action.payload
                }
            }
        case Events.CUSTOMER_INFO_LOADED:
            return {
                ...state,
                customerInfo: {
                    ...action.payload
                }
            }
        case Events.PAYMENT_METHOD_REMOVED:
            return {
                ...state,
                paymentMethods: state.paymentMethods.filter(paymentMethod => (
                    paymentMethod.id !== action.payload
                ))
            }
        default:
            return state;
    }
}